import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "outer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcSelectTags = _resolveComponent("NcSelectTags")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NcSelectTags, {
      ref: "selectTags",
      class: "nc-component",
      modelValue: _ctx.tagSelection,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tagSelection) = $event)),
      "label-outside": true,
      disabled: _ctx.disabled,
      limit: null,
      "options-filter": _ctx.tagFilter,
      "get-option-label": _ctx.tagLabel,
      "create-option": _ctx.createOption,
      taggable: true,
      "onOption:created": _ctx.handleCreate
    }, null, 8, ["modelValue", "disabled", "options-filter", "get-option-label", "create-option", "onOption:created"])
  ]))
}